module.exports = __webpack_public_path__ + "img/high-school-course-title.8b5dea61.svg";